export const NotifObjectType = {
	general: 0,
	order: 1,
	deviation: 2,
};
